import { Device } from '../models/device.model';
import { MfaDeviceService } from '../services/mfa-device.service';
/**
 * @license
 * Copyright (c) Absa Group Limited, All Rights Reserved.
 */
import { Component, ViewEncapsulation, ViewChild, Output, EventEmitter, ElementRef, Input } from '@angular/core';
import { catchError } from 'rxjs/operators';

// UI Actions
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'delink-device',
  encapsulation: ViewEncapsulation.Emulated,
  template: require('./delink-device.component.html'),
  styles: [`
	.modal .modal-dialog.modal-lg{ max-width: 400px; } 
	.modal-title{ font-weight: 400; }
	`]
})

export class DelinkDeviceComponent {
  @ViewChild('delinkDevice') delinkDeviceTemplate: ElementRef;
  @Output() rowsUpdated: EventEmitter<any> = new EventEmitter<any>();

  public delinkModalLoading: boolean = false;
  public delinkDeviceStatus: string;
  public deviceCode: string;
  public delinkStep: number;
  public selectedDevice: Device;

  constructor(
    private modalService: NgbModal,
    private mfaDeviceService: MfaDeviceService,
  ) { }

  public delinkDeviceModal(row: Device) {
    this.deviceCode = null;
    this.delinkDeviceStatus = null;
    this.selectedDevice = row;

    this.modalService.open(this.delinkDeviceTemplate, {
      size: 'sm',
      backdrop: 'static',
      keyboard: false
    }).result.then(() => {
    }, () => {
    });
  }

  public setCode(deviceCode: string) {
    this.deviceCode = deviceCode;

    if (deviceCode) {
      this.delinkModalLoading = true;
      this.mfaDeviceService.postDeactivateDevice(deviceCode)
        // catch and return https://github.com/angular/angular/issues/26817
        .pipe(catchError(err => Observable.of(err)))
        .subscribe((response) => {

          if (response && response.status) {
            this.delinkDeviceStatus = 'error';
            this.delinkModalLoading = false;
          }
          if (!response) {
            this.delinkDeviceStatus = 'success';
            this.delinkModalLoading = false;
            this.rowsUpdated.emit([]);
          }
        });
    }
  }

  public retryDelink() {
    this.delinkStep = 1;
    this.deviceCode = null;
    this.delinkDeviceStatus = null;
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/manage-mfa-device/delink-device/delink-device.component.ts